<!--
 * @Author: your name
 * @Date: 2020-11-21 14:36:13
 * @LastEditTime: 2020-12-23 16:10:02
 * @LastEditors: shiao
 * @Description: In User Settings Edit
 * @FilePath: \o2o-app\src\components\image-preview.vue
-->
<template>
    <van-image-preview
    v-model="previewshow"
    :images="images"
    :startPosition="previewstartPosition"
    className="image-preview-background"
    :asyncClose="asyncClose"
  >
    <template v-slot:cover>
      <div class="image-preview-close-btn" @click="close">
        <img :src="closeicon" alt="" />
      </div>
    </template>
  </van-image-preview>
</template>

<script>
export default {
  props: {
    previewshow: {
      required: true,
      type: Boolean,
    },
    previewstartPosition: {
      type: Number,
      default: 0,
    },
    images: {
      required: true,
      type: Array,
    },
    closeicon: {
      type: String,
      default: require("@/assets/shared-hotel/close-icon.png"),
    },
    asyncClose: {
      type: Boolean,
      default: true,
    },
  },
  watch:{
    previewshow(newval){
      this.previewshow = newval
    }
  },
  methods: {
    close() {
      this.$emit("closepreview");
    },
  },
};
</script>

<style lang="less">
.image-preview-background {
  background: #000000;
}
.image-preview-close-btn {
  width: 18px;
  height: 18px;
  position: fixed;
  top: 60px;
  left: 16px;
  z-index: 2100;
  img {
    width: 100%;
  }
}
.van-image-preview__index {
  font-size: 16px;
  top: 60px;
}
</style>